import _noop from "lodash/noop";
import * as React from 'react';
export var TreeContext = /*#__PURE__*/React.createContext({
  getItemById: function getItemById(id) {
    return {
      id: id
    };
  },
  registerItemRef: _noop,
  toggleItemActive: _noop,
  focusItemById: _noop,
  expandSiblings: _noop,
  toggleItemSelect: _noop,
  getToFocusIDByFirstCharacter: function getToFocusIDByFirstCharacter(e, id) {
    return id;
  }
});